import "./ScrollUp.css";
import { useEffect, useRef } from "react";
import KeyboardArrowUpRoundedIcon from '@mui/icons-material/KeyboardArrowUpRounded';

const ScrollUp = () => {
  const offset = 100;
  const scrollUp = useRef(null);
  const scrollUpSvgPath = useRef(null);

  const onClick = () => {
    window.scroll({ top: 0 });
  };
  useEffect(() => {
    const pathLength = scrollUpSvgPath.current.getTotalLength();

    const getTop = () =>
      window.pageYOffset || document.documentElement.scrollTop;

    scrollUpSvgPath.current.style.strokeDasharray = `${pathLength} ${pathLength}`;
    scrollUpSvgPath.current.style.transition = "stroke-dashoffset 20ms";

    const updateDashoffset = () => {
      const height = document.documentElement.scrollHeight - window.innerHeight;
      const dashoffset = pathLength - (getTop() * pathLength) / height;
      if (scrollUpSvgPath.current) {
        scrollUpSvgPath.current.style.strokeDashoffset = dashoffset;
      }
    };
    window.addEventListener("scroll", () => {
      if (getTop() > offset) {
        scrollUp?.current?.classList.add("scrollUp--active");
      } else {
        scrollUp?.current?.classList.remove("scrollUp--active");
      }
      updateDashoffset();
    });
  });

  return (
    <div onClick={onClick} ref={scrollUp} className="scrollUp">
      <svg className="scrollUp__svg" viewBox="-2 -2 52 52">
        <path
          ref={scrollUpSvgPath}
          className="scrollUp__svg-path"
          d="M24, 0 a24,24 0 0,1 0, 48a24,24 0 0,1 0, -48"
        />
      </svg>
      <KeyboardArrowUpRoundedIcon className="scrollUp-icon" />
    </div>
  );
};

export default ScrollUp;
